import type { SupportedLanguage } from './index'

/**
 * Localized route definitions for AD Aesthetics.
 * Each key maps to route segments per language.
 */
export const localizedRoutes = {
  home: {
    it: '',
    en: '',
  },
  breastSurgery: {
    it: 'chirurgia-estetica-seno',
    en: 'breast-surgery',
  },
  bodySurgery: {
    it: 'chirurgia-estetica-corpo',
    en: 'body-surgery',
  },
  faceSurgery: {
    it: 'chirurgia-estetica-viso',
    en: 'face-surgery',
  },
  bodyAesthetic: {
    it: 'medicina-estetica-corpo',
    en: 'body-aesthetic-medicine',
  },
  faceAesthetic: {
    it: 'medicina-estetica-viso',
    en: 'face-aesthetic-medicine',
  },
  regenerative: {
    it: 'medicina-rigenerativa',
    en: 'regenerative-medicine',
  },
  laser: {
    it: 'trattamenti-laser',
    en: 'laser-treatments',
  },
  blog: {
    it: 'blog',
    en: 'blog',
  },
  bookConsultation: {
    it: 'prenota-consulenza',
    en: 'book-consultation',
  },
  contacts: {
    it: 'contatti',
    en: 'contacts',
  },
  privacy: {
    it: 'privacy',
    en: 'privacy',
  },
  cookiePolicy: {
    it: 'cookie-policy',
    en: 'cookie-policy',
  },
  treatment: {
    it: ':categorySlug/:treatmentSlug',
    en: ':categorySlug/:treatmentSlug',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
